import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-arrow-down',
  templateUrl: './icon-arrow-down.component.html',
  styleUrls: ['./icon-arrow-down.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconArrowDownComponent {}
